<footer>
    <div class="container">
  

        <div class="row pt-5">
            <div class="col-sm-6 col-lg-3">
                <div class="footer-item">
                    <div class="footer-logo">
                        <!--<h2 class="text-white">Job Fair</h2>-->
                        <a href="#home"><img width="100px" height="auto" src="assets/img/home-1/9.png"></a>
                        <p>Ministerio di Hustisia di Kòrsou, ta e wesu di lomba di e un komunidat safe, liber i hustu. Kaminda tur hende, independientemente di su estilo di bida òf kreensia, por biba den harmonia ku otro.  </p>
                       
                    </div>
                </div>
            </div>

            <div class="col-sm-6 col-lg-3">
                <div class="footer-item">
                    <div class="footer-category">
                        <h3>Kategoria</h3>
                        <ul>
                            <li *ngFor="let organization of organizations"><a routerLink="/organization/{{organization.id}}"><i class="icofont-simple-right"></i>{{organization.name}}</a></li>
                            
                        </ul>
                    </div>
                </div>
            </div>

            <div class="col-sm-6 col-lg-3">
                <div class="footer-item">
                    <div class="footer-category">
                        <h3>Informashon</h3>

                        <ul>
                            <li><a href="https://mevoz.net/minjus/Bezoldigingsschalen.pdf" target="_blank"><i class="icofont-simple-right"></i> Bezoldigingsschalen</a></li>
                            <li><a routerLink="/disclaimer"><i class="icofont-simple-right"></i> Aarbeidsvoorwaarden</a></li>
                            <li><a routerLink="/job-list"><i class="icofont-simple-right"></i> Vakatura</a></li>
           
                            
                        </ul>
                    </div>
                </div>
            </div>

            <div class="col-sm-6 col-lg-3">
                <div class="footer-item">
                    <div class="footer-find">
                      
                    </div>
                </div>
            </div>
        </div>

        <div class="copyright-area">
            <div class="row">
                <div class="col-lg-6">
                    <div class="copyright-item">
                        <p>© Traboudenhustisia.com - Ministerie van Justitie</p>
                    </div>
                </div>

                <div class="col-lg-6">
                    <div class="copyright-item copyright-right">
                  
                    </div>
                </div>
            </div>
        </div>
    </div>
</footer>